var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasketInBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    x: 0.174,
    y: 0.457,
    fill: "#383940",
    rx: 4.435
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33,
    d: "m11.63 8.217-2.77 3.696v12.935a1.848 1.848 0 0 0 1.848 1.848H23.64a1.848 1.848 0 0 0 1.848-1.848V11.913l-2.772-3.696H11.63Zm-2.771 3.696h16.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33,
    d: "M20.87 15.609a3.696 3.696 0 0 1-7.392 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketInBox);
export default __webpack_public_path__ + "static/media/basket-in-box.bb7dcf61.svg";
export { ForwardRef as ReactComponent };